import { connect } from 'react-redux';

import { Graph, IGraphProps } from '../../../components/Graph';
import { IApplicationState } from '../../../types/redux';
import { getLabels, getDatasets } from '../selectors';

type TStoreProps = Pick<IGraphProps, 'isLoading' | 'labels' | 'datasets' | 'graphValuesType'>;

export function mapStateToPropsGraph(state: IApplicationState): TStoreProps {
  return {
    isLoading: state.graphs.isLoading,
    labels: getLabels(state.graphs),
    datasets: getDatasets(state.graphs, state.graphs.regionGraph),
    graphValuesType: state.graphs.graphValuesType,
  };
}

export const GraphContainer = connect(mapStateToPropsGraph)(Graph);
